import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import useNavigation from '@/navigation/useNavigation';
import ImageFileUtils from '@/utils/ImageFileUtils';
import CameraIcon from '../../assets/icon/ic_camera.svg';
import CircleCloseIcon from '../../assets/icon/ic_circle_close.svg';
import * as S from './Photos.style';
export default function Photos({ value, maxPhotos, target, onChange }) {
    const navigation = useNavigation();
    const takePhoto = () => {
        navigation.navigate('Camera', {
            takenPhotos: value,
            onPhotosTaken: onChange,
            target,
        });
    };
    const deletePhoto = (photo) => {
        const newPhotos = value.filter(p => p.uri !== photo.uri);
        onChange(newPhotos);
    };
    const hasPhotos = value.length > 0;
    return (_jsxs(S.Photos, { children: [hasPhotos && value.length < maxPhotos && (_jsx(S.Photo, { children: _jsx(S.SmallCameraButton, { elementName: "photo_small_camera_button", onPress: takePhoto, children: _jsx(CameraIcon, { width: 36, height: 36 }) }) })), value.slice(0, 3).map((photo, index) => (_jsxs(S.Photo, { children: [_jsx(S.Thumbnail, { elementName: "photo_thumbnail", logParams: { photo_index: index }, onPress: () => {
                            navigation.navigate('ImageZoomViewer', {
                                imageUrls: value.map(p => ImageFileUtils.filepathFromImageFile(p)),
                                index,
                            });
                        }, children: _jsx(S.ThumbnailImage, { source: { uri: ImageFileUtils.filepathFromImageFile(photo) } }) }), _jsx(S.DeleteButton, { elementName: "photo_delete_button", onPress: () => deletePhoto(photo), children: _jsx(CircleCloseIcon, { width: 24, height: 24 }) })] }, photo.uri))), value.length === 1 && _jsx(S.Photo, {}), !hasPhotos && (_jsx(S.TakePhoto, { children: _jsxs(S.TakePhotoButton, { elementName: "photo_take_button", onPress: takePhoto, children: [_jsx(CameraIcon, { width: 28, height: 28 }), _jsx(S.TakePhotoText, { children: "\uC0AC\uC9C4 \uCD2C\uC601\uD558\uAE30" })] }) }))] }));
}
